import { render, staticRenderFns } from "./EMelderComponentMeldenBs3EingabeTextLang.vue?vue&type=template&id=6ac96552"
import script from "./EMelderComponentMeldenBs3EingabeTextLang.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs3EingabeTextLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports